module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1040-66a5ea1aa306e0cef006677397b31f13.png";